import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { Global } from '../../global';
import { Observable } from 'rxjs';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { InvoiceService } from '../../../services/Acc_InvoiceService';
import { MatDatepickerInputEvent, MatSnackBar, SELECT_PANEL_INDENT_PADDING_X } from '@angular/material';
import * as moment from 'jalali-moment';
import { DariCalendarService } from '../../../services/DariCalendar';
import { MatDialog } from '@angular/material';
import * as $ from 'jquery';
import { ExcelService } from '../../../services/ExcelService';
import { UserDetails } from '../../../models/userDetails.interface';
import { UserService } from '../../../services/user.service';
import { DashboardService } from '../../../services/dashboard.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.css']
})
export class CardListComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};
  StudentAccounts: any;
  selectedAccountNumber: string = 'all';
  selectedAccountName: string;
  clear_status: string = 'A';
  expiry_status: string = 'A';
  semester: number = 0;
  fromDate: string;
  toDate: string;
  isPrintable: boolean;
  isFeeSemester: boolean = false;
  ArrAccountMaps: any;
  studentMasterAccount: string;
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  cardList: any = {};
  departmentList: any;
  st_department: string = 'all';
  type_card: number = 0;
  printVariables: any = {};
  recordCount: number;
  amount_sum: number = 0;
  userDetails: UserDetails;
  branch: string;
  DateCheck = true;
  constructor(
    public dialog: MatDialog,
    private UtilityService: UtilityService,
    private CardService: GL_MasterService,
    private DariCalendar: DariCalendarService,
    private snackBar: MatSnackBar,
    private excelService: ExcelService,
    private userDetailService: DashboardService
  ) {
    //this.getInvoices();
    this.userDetailService.getUserDetails()
      .subscribe((userDetails: UserDetails) => {
        this.userDetails = userDetails;
        console.log(`user details ` + this.userDetails["email"]);
      }, error => {
        console.log(error);
      });
  }

  ngOnInit() {
    this.getBranchId();
    this.getDepartments();
  }

  is_allow_save: boolean = true;
  isBranchId: number = -1;
  userId: string = "0";
  getBranchId() {
    console.log("getBranchId:start")
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId;
    }
    console.log(`getBranchId:${this.isBranchId}`);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.StudentAccounts.filter(option => option.gL_ChildCode.toLowerCase().includes(filterValue));
  }

  getDepartments() {
    this.departmentList = this.UtilityService.getDepartments().subscribe(response => {
      console.log(response);
      this.departmentList = response;
    }
    )
  }

  AccountChanged(event, gL_ChildDesc, gL_ChildCode) {
    console.log(event.isUserInput);
    if (event.isUserInput === true) {
      console.log(gL_ChildDesc);
      this.selectedAccountName = gL_ChildDesc;
    }
  }

  FromDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.fromDate = _date;
    //this.fromDate_DariDate = _pdate;
  }

  ToDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.toDate = _date;
  }

  getCards() {
    this.CardService.getCards(this.selectedAccountNumber, this.fromDate, this.toDate, this.semester, this.st_department, this.type_card , this.isBranchId, this.userId)
      .subscribe(response => {
        this.cardList = response.json();
        this.recordCount = this.cardList.length;
        this.amount_sum = 0;
        let fullName = "";
        for (let inv in this.cardList) {
          if (this.cardList[inv].fullName.indexOf(' ولد ') > 0) {
            fullName = this.cardList[inv].fullName.split(' ولد ');
            this.cardList[inv].fullName = fullName[0];
            if (fullName.length > 1)
              this.cardList[inv].fullNameFather = fullName[1];
          }
          if (this.cardList[inv].datePrintCard1)
            this.cardList[inv].datePrintCard1_da = this.DariCalendar.PersianCalendar(new Date(this.cardList[inv].datePrintCard1));
          if (this.cardList[inv].datePrintCard2)
            this.cardList[inv].datePrintCard2_da = this.DariCalendar.PersianCalendar(new Date(this.cardList[inv].datePrintCard2));
        }
      });
  }


  @ViewChild('tableReport') table: ElementRef;
  exportAsXLSX(): void {
    //this.excelService.exportAsExcelFile(this.cardList, 'cardList');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'invoiceList.xlsx');
  }

  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }

  printFilteredInvoices() {
    setTimeout(() => {
      var printWindow: any
      var content = $("#reportContent").prop('outerHTML');

      printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write(' <style> .action-row { display: none; }  </style>    </head><body  style="-webkit-print-color-adjust: exact; margin:25px; border: 1px solid #000; margin-top: 1px;direction: rtl; "  >');

      printWindow.document.write(`
      <table class="table AESLog table-responsive" style="font-family: IranianSansRegular;">
      <tr>
        <td style="width:25vw;">
          <img src="/assets/images/ministry.jpg" width="145px"; style="float:right;"/> 
        </td>
        <td style="text-align:center; width:50vw;">
            وزارت تحصیلات عالی<br />
            ریاست محصلان خصوصی<br />
            موسسه تحصیلات عالی طبی افغان سویس<br />
          <p> لیست کارتهای شمولیت </p>
        </td>
        <td style="width:25vw;" >
          <img src="/assets/images/rbulogo.gif" width="140px" style="float:left"/>
        </td>

      </tr>
    </table> `);

      printWindow.document.write(content);
      //printWindow.document.write(`<script> $(".btnprint").css("display", "none");</script>
      //<script> $(".btndelete").css("display", "none"); $(".btnReverse").css("display", "none");$(".btnEdit").css("display", "none");</script>  </body ></html>`);

    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/card/card-list/card-list.component.ts